export function formatSeverity(priority: number) {
  if (priority >= 0 && priority <= 3) {
    return 0;
  } else if (priority >= 4 && priority <= 6) {
    return 1;
  } else if (priority >= 7 && priority <= 9) {
    return 2;
  } else {
    return 3;
  }
}
